import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

/**
 * MiniSparkline – Özet kartlarının altında kullanılan küçük eğilim grafiği.
 *
 * Eksen, ızgara ve araç çubuğu kapalıdır; yalnızca eğri ve tooltip gösterilir.
 *
 * @param {number[]} data        Değerler (eskiden yeniye)
 * @param {string[]} categories  Tooltip'te gösterilecek etiketler (ör. tarihler)
 * @param {string} color         Çizgi/dolgu rengi
 * @param {number} height        Yükseklik (px)
 * @param {string} name          Tooltip serisi adı
 * @param {Function} formatter   Tooltip değer biçimlendirici
 */
const MiniSparkline = ({
    data = [],
    categories = [],
    color = "#221C5D",
    height = 46,
    name = "Değer",
    formatter,
}) => {
    const options = useMemo(() => {
        // tooltip.y yalnızca formatter verildiğinde eklenir; undefined atanırsa
        // ApexCharts kendi varsayılan y.formatter'ını kaybedip hata veriyor.
        const tooltip = {
            fixed: { enabled: false },
            x: { show: categories.length > 0 },
            marker: { show: false },
        };
        if (formatter) tooltip.y = { formatter: (v) => formatter(v) };

        return {
            chart: {
                type: "area",
                sparkline: { enabled: true },
                animations: { enabled: false },
                parentHeightOffset: 0,
            },
            colors: [color],
            stroke: { curve: "smooth", width: 2 },
            fill: {
                type: "gradient",
                gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.02, stops: [0, 100] },
            },
            tooltip,
            xaxis: { categories },
            dataLabels: { enabled: false },
        };
    }, [color, categories, formatter]);

    // Tüm değerler sıfırsa Apex düz bir çizgi çizemiyor; boş alan bırakmak daha temiz
    const hasValue = data.some((v) => Number(v) > 0);
    if (!data.length || !hasValue) {
        return <div style={{ height }} />;
    }

    return (
        <ReactApexChart
            options={options}
            series={[{ name, data }]}
            type="area"
            height={height}
        />
    );
};

// Üst bileşen her render olduğunda grafiği yeniden çizmemek için memo'lanır
export default React.memo(MiniSparkline);
